import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/base-components';

export const ShareTriggerButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
})`
  height: auto;
  padding: 4px;
`;

export const CloseButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
  width: 'auto',
})`
  height: auto;
  padding: 2px;
`;

export const ShareTextAsButton = styled(Text).attrs({
  color: 'primaryBase',
  size: 'normal',
})`
  cursor: pointer;
`;

interface TabLabelProps {
  isActive: boolean;
}

export const TabLabelWrapper = styled(Box).attrs<TabLabelProps>(
  ({ isActive }) => ({
    py: '4px',
    cursor: 'pointer',
    borderBottom: '2px solid',
    borderColor: isActive ? 'primaryBase' : 'transparent',
  }),
)<TabLabelProps>``;

export const TabLabel = styled(Text).attrs<TabLabelProps>(({ isActive }) => ({
  fontWeight: 'bold',
  color: isActive ? 'primaryText' : 'secondaryText',
  size: 'normal',
}))<TabLabelProps>``;
